import { useCallback, useState } from 'react';

interface NotificationData {
  title: string;
  body: string;
  icon?: string;
}

export const useCustomNotificationToast = () => {
  const [notification, setNotification] = useState<NotificationData | null>(
    null
  );

  const showNotification = useCallback((notificationData: NotificationData) => {
    setNotification(notificationData);
  }, []);

  const hideNotification = useCallback(() => {
    setNotification(null);
  }, []);

  return {
    notification,
    showNotification,
    hideNotification
  };
};
